import {getRequest} from './apiRequests';
import localStorageRepository from '@/domain/repository/LocalStorageRepository';
import {Parcel} from '@/domain/entities/Parcel';

const parcelRepository = {
  getParcelsByProject: (projectUuid: string): Promise<Array<Parcel>> => {
    const {access} = localStorageRepository.getCredentials();
    return getRequest<Array<Parcel>>({
      path: `projects/${projectUuid}/parcels/`,
      headers: {
        'Authorization': `Bearer ${access}`
      }
    });
  },
  getParcelByUuid: (parcelUuid: string): Promise<Parcel> => {
    const {access} = localStorageRepository.getCredentials();
    return getRequest<Parcel>({
      path: `parcels/${parcelUuid}`,
      headers: {
        'Authorization': `Bearer ${access}`
      }
    });
  }
};

export default parcelRepository;